import React from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";

/**
 * Keeps signed-out visitors out of the application shell.
 *
 * This is a navigation affordance, not a security boundary: `isAuthenticated`
 * is rehydrated from localStorage and can be edited by anyone with devtools.
 * Every protected endpoint must enforce authorization server-side.
 */
const ProtectedRoute = () => {
  const isAuthenticated = useSelector((state) => state.user.isAuthenticated);

  if (isAuthenticated) {
    return <Outlet />;
  }
  return <Navigate to="/" replace />;
};

export default ProtectedRoute;
